import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';

import {Destroyable} from '../../../destroyable.component';
import {prettyJson} from '../../utils/json';
import {SdcEventTypes, SdcLogDTO} from '../sdconnect.model';

@Component({
  selector: 'gp-sdc-log',
  templateUrl: './sdc-log.component.html',
  styleUrls: ['./sdc-log.component.scss']
})
export class SdcLogComponent extends Destroyable {

  protected readonly SdcEventTypes = SdcEventTypes;

  @Input() public sdcLog: SdcLogDTO;

  public timezone: string;

  constructor(private router: Router) {
    super();
  }

  public getPrettyJson(data: string): string {
    return prettyJson(data || '{}');
  }
}
